// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2x5VH","title":"Info_title__2bXw_","links":"Info_links__3V7nv","link":"Info_link__3ba70","logo":"Info_logo__2ZHGu"};